import { render, staticRenderFns } from "./case-update-card.vue?vue&type=template&id=06e25fa4&scoped=true&"
import script from "./case-update-card.vue?vue&type=script&lang=js&"
export * from "./case-update-card.vue?vue&type=script&lang=js&"
import style0 from "./case-update-card.vue?vue&type=style&index=0&id=06e25fa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e25fa4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDivider,VHover,VIcon})
